const cookies = {
  COOKIE_BANNER: 'civicCookieControl',
};

export default cookies;
